import { motion } from "framer-motion";
import { CheckCircle2, Award, Users, Calendar } from "lucide-react";

const AboutSection = () => {
  const highlights = [
    { icon: Calendar, text: "Years of experience" },
    { icon: Award, text: "Fully qualified team" },
    { icon: Users, text: "Friendly professional service" },
    { icon: CheckCircle2, text: "Free quotations" },
  ];

  return (
    <section id="about" className="py-16 md:py-24 lg:py-32 bg-[#F9F9F7]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/53o6flpy_new2.jpg"
                alt="Pioneer Trees and Landscapes full garden transformation with water feature"
                className="w-full h-[400px] lg:h-[500px] object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <div className="flex items-center gap-4 text-white">
                  <div className="text-center">
                    <div className="text-3xl font-bold font-heading">15+</div>
                    <div className="text-sm text-white/80">Years</div>
                  </div>
                  <div className="w-px h-12 bg-white/30" />
                  <div className="text-center">
                    <div className="text-3xl font-bold font-heading">500+</div>
                    <div className="text-sm text-white/80">Projects</div>
                  </div>
                  <div className="w-px h-12 bg-white/30" />
                  <div className="text-center">
                    <div className="text-3xl font-bold font-heading">100%</div>
                    <div className="text-sm text-white/80">Insured</div>
                  </div>
                </div>
              </div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#1A4D2E]/10 rounded-2xl -z-10" />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-sm font-medium tracking-wide uppercase text-[#8B5A2B] mb-4 block">
              About Us
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A4D2E] mb-6">
              Your Local Landscaping Specialists
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              Pioneer Trees and Landscapes Ltd are specialists in landscaping and grounds maintenance, based in and around Northumberland. From new driveways and patios to full garden transformations and tree surgery — we do it all.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              We work on either a contract or private basis, keeping your outdoor spaces maintained all year round. Our commitment to quality workmanship, fair pricing and good communication has made us Northumberland's trusted choice for landscaping.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-4">
              {highlights.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm"
                >
                  <div className="w-10 h-10 rounded-lg bg-[#1A4D2E]/10 flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-5 h-5 text-[#1A4D2E]" />
                  </div>
                  <span className="text-sm font-medium text-gray-700">{item.text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
